import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [], // Change from {} to []
};

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload; // Action payload is already an array from server
    },
    userOnline: (state, action) => {
      const userId = action.payload;
      const userIndex = state.users.findIndex((user) => user.Id === userId);
      if (userIndex >= 0) {
        state.users[userIndex].onlineStatus = "online";
      } else {
        state.users.push({ Id: userId, onlineStatus: "online" });
      }
    },
    userOffline: (state, action) => {
      const userId = action.payload;
      const userIndex = state.users.findIndex((user) => user.Id === userId);
      if (userIndex >= 0) {
        state.users[userIndex].onlineStatus = "offline";
      }
    },
  },
});

export const { setUsers, userOnline, userOffline } = socketSlice.actions;

export default socketSlice.reducer;
